<template>
    <div>
        <v-main>
            <span :class="{'bg2': isChristmas(), 'bg3': isSinterklaas()&&!showAccoList}"></span>
            <v-container fluid class="relative">
                <v-row justify="center" cols="12">
                    <v-col cols="2" v-if="showAccoList">
                        <new_accos class="new-accos" @hide="hideAccoList" style="width:16vw;"/>
                    </v-col>
                    <v-col v-else cols="1">
                        <div class="mock-href" @click="showThisList()">Show <v-icon medium color="#0000ff">mdi-home-group</v-icon> list week {{ getThisWeekNumber() }}</div>
                    </v-col>
                    <v-col cols="10" lg="10">
                        <v-row cols="12">
                            <v-col v-for="card in cards" :key="card.key" :xs="card.xs" :sm="card.sm" :md="card.md" :lg="card.lg" :xl="card.xl" class="pa-0 ma-0">
                                <div v-if="card.tag == 'header'" class="pa-2">
                                    <xheader :gebr="gebr" :online="online" :mybooking="mybooking" :myvilla="myvilla" id="xheader" />
                                </div>
                                <div v-if="card.tag == 'leads1'">
                                    <countPten ref="countPten" :agent="gebr.gebr_code" :cardActions="false"/>
                                </div>
                                <div v-if="card.tag == 'leads2'">
                                    <countPtenAction ref="countPtenAction" :agent="gebr.gebr_code" :cardActions="false"/>
                                </div>
                                <div v-if="card.tag == 'revscorev2'" class="pa-1 pb-0">
                                    <score2 />
                                </div>
                                <div v-if="card.tag == 'bookings5'" class="pa-1">
                                    <bookings5 />
                                </div>
                                <div v-if="card.tag == 'season1'" class="pa-1">
                                    <season1 />
                                </div>
                                <div v-if="card.tag == 'arrivals1'" class="pa-1">
                                    <arrivals1 id="arrivals" />
                                </div>
                                <div v-if="card.tag == 'arrivalsyear1'" class="pa-1">
                                    <arrivalsyear1 />
                                </div>
                                <div v-if="card.tag == 'agentaccostats1'" class="pa-1">
                                    <agentaccostats1 />
                                </div>
                                <div v-if="card.tag == 'agentaccostatsman1'" class="pa-1">
                                    <agentaccostatsman1 />
                                </div>
                                <div v-if="card.tag == 'dailybookings1'" class="pa-1">
                                    <dailybookings1 />
                                </div>
                                <div v-if="card.tag == 'champagne'" class="pa-1">
                                    <champagne />
                                </div>
                                <div v-if="card.tag == 'damages'" class="pa-1">
                                    <damages v-bind:gebr="gebr" id="damages"/>
                                </div>
                                <div v-if="card.tag == 'complaints'" class="pa-1">
                                    <complaints v-bind:gebr="gebr" id="complaints"/>
                                </div>
                                <div v-if="card.tag == 'availability0'" class="pa-1">
                                    <availability0 id="availability" />
                                </div>
                                <div v-if="card.tag == 'reviews'" class="pa-1">
                                    <reviews v-bind:gebr="gebr" id="reviews" />
                                </div>
                                <div v-if="card.tag == 'rebookings'" class="pa-1">
                                    <rebookings v-bind:gebr="gebr" id="rebookings" />
                                </div>
                                <div v-if="card.tag == 'changes'" class="pa-1">
                                    <changes v-bind:gebr="gebr" id="changes" />
                                </div>
                                <div v-if="card.tag == 'agentbookings'" class="pa-1">
                                    <agentbookings v-bind:gebr="gebr" id="agentbookings" />
                                </div>
                                <div v-if="card.tag == 'agentlayouterrors'" class="pa-1">
                                    <agentLayoutErrors v-bind:gebr="gebr" id="agentlayouterrors" />
                                </div>
                                <div v-if="card.tag == 'agentonboarding'" class="pa-1">
                                    <agentOnboarding v-bind:gebr="gebr" id="agentonboarding" />
                                </div>
                                <div v-if="card.tag == 'hostChangeRequests'" class="pa-1">
                                    <hostChangeRequests v-bind:gebr="gebr" id="hostChangeRequests" />
                                </div>
                                <div v-if="card.tag == 'accommodationActions'" class="pa-1">
                                    <accommodationActions v-bind:gebr="gebr" id="accommodationActions" />
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col v-if="!showAccoList" cols="1"></v-col>
                </v-row>
            </v-container>
        </v-main>
        <navBar title="Ares - Main menu" :home="true" :accolist="true" type="main"/>
    </div>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import score2 from './cards/revscorev2.vue';
    import bookings5 from './cards/bookings_v5.vue';
    import champagne from './cards/champagne.vue';
    import damages from './cards/damages.vue';
    import complaints from './cards/complaints.vue';
    import agentbookings from './cards/agentBookings_v0.vue';
    import agentLayoutErrors from './cards/agentLayoutErrors.vue';
    import agentOnboarding from './cards/agentOnboarding.vue';
    import rebookings from './cards/rebookings.vue';
    import changes from './cards/changes.vue';
    import hostChangeRequests from './cards/hostChangeRequests.vue';
    import accommodationActions from './cards/accommodationActions.vue';
    import xheader from './cards/headerv2.vue';
    import availability0 from './cards/availability_v0.vue';
    import reviews from './cards/reviews.vue';
    import season1 from './cards/season_v2.vue';
    import arrivals1 from './cards/arrivals_v1.vue';
    import arrivalsyear1 from './cards/arrivals_yearv2.vue';
    import dailybookings1 from './cards/daily_bookingsv1.vue';
    import agentaccostats1 from './cards/agent_accostatsv1.vue';
    import agentaccostatsman1 from './cards/agent_accostats_manv1.vue';
    import new_accos from './cards/new_accos.vue';
    import countPten from '@/components/pten/countPten.vue';
    import countPtenAction from '@/components/pten/countPtenAction.vue';


    import {bus} from "../../../main";
    import * as easings from 'vuetify/lib/services/goto/easing-patterns';

    export default {
        components: {
            score2,
            bookings5,
            availability0,
            dailybookings1,
            agentaccostats1,
            agentaccostatsman1,
            champagne,
            xheader,  // header is reserved, hence xheader.
            damages,
            complaints,
            season1,
            arrivals1,
            arrivalsyear1,
            reviews,
            rebookings,
            changes,
            hostChangeRequests,
            navBar,
            new_accos,
            countPten,
            countPtenAction,
            agentbookings,
            agentLayoutErrors,
            agentOnboarding,
            accommodationActions,
        },
        computed: {
            current_size: function() {
                return this.$vuetify.breakpoint.name;
            },
            options () {
                return {
                    duration: this.duration,
                    offset: this.offset,
                    easing: this.easing,
                }
            },
        },
        data() {
            return {
                cards: [],
                gebr: {},
                online: {},
                mybooking: {},
                myvilla: {},
                fab: false,
                last_update:'',
                duration: 1000,
                offset: 0,
                switch: false,
                easing: 'easeInCubic',
                easings: Object.keys(easings),
                showAccoList: true,
            }
        },
        methods: {
            hideAccoList(){
                this.showAccoList = false;
            },
            getLogin(){
                return localStorage.getItem('login')
            },
            showThisList(){
                localStorage.setItem('newacco.hide', '')
                this.showAccoList = true
            },
            isChristmas(){
                let currentDate = new Date();
                let activationDate = null;
                let deActivationDate = null;
                switch (currentDate.getMonth()){
                    case 11:
                        activationDate = new Date(currentDate.getFullYear(), 11, 6, 0, 0); // always activate on december 6th (month is zerobased)
                        deActivationDate = new Date(currentDate.getFullYear() + 1, 0, 6, 0, 0); // always deactivate on january 5th next year (month is zerobased)
                        return currentDate >= activationDate && currentDate <= deActivationDate;
                    case 0:
                        activationDate = new Date(currentDate.getFullYear() - 1, 11, 6, 0, 0); // always activate on december 6th (month is zerobased)
                        deActivationDate = new Date(currentDate.getFullYear(), 0, 6, 0, 0); // always deactivate on january 5th next year (month is zerobased)
                        return currentDate >= activationDate && currentDate <= deActivationDate;
                    default:
                        return false;
                }
            },
            isSinterklaas(){
                let currentDate = new Date();
                return currentDate.getMonth() === 11 && currentDate.getDate() === 5;
            },
            getHideAccoList(){
                let hideforweek = localStorage.getItem('newacco.hide');
                if(hideforweek !== null){ // we have a setting
                    if (hideforweek == this.getThisWeekNumber()) {  // losely compare
                        this.showAccoList = false // hidden for this week
                    } else {
                        this.showAccoList = true // may be hidden for some week but not this week
                    }
                } else {
                    this.showAccoList = true; // setting found so do show
                }
            },
            getThisWeekNumber(){
                let w = this.$moment(new Date()).isoWeek() - 1
                return w===0?this.$moment(new Date((new Date().getFullYear() - 1), 11, 31, 0, 0, 0)).isoWeek():w
            },
            sendRefresh(){
                bus.$emit("refresh","all");
            },
            scrollToTop(){
                this.$vuetify.goTo(document.getElementById("xheader"), this.options);
                this.switch=false;
            },
            dynamicSort(property) {
                var sortOrder = 1;
                if (property[0] === "-") {
                    sortOrder = -1;
                    property = property.substr(1);
                }
                return function (a, b) {
                    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                    return result * sortOrder;
                }
            },
            getDashboardData() {
                this.$axios.post("ares/json/ares/syst/dashboard/getDashboardDatav16.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getDashboardData"
                    },
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.gebr = res.data.getDashboardData.gebr;
                        this.cards = res.data.getDashboardData.cards;
                        this.online = res.data.getDashboardData.online;
                        this.mybooking = res.data.getDashboardData.mybooking;
                        this.myvilla = res.data.getDashboardData.myvilla;
                        this.cards.sort(this.dynamicSort("sort"));
                    }
                });
            }
        },
        mounted() {
            this.getHideAccoList();
        },
        created() {
            this.getDashboardData();
            bus.$on("refresh", (data) => {
                console.log("refresh received for frame " + data);
            });
            bus.$on("scroll_to", (data) => {
                this.switch=true; //switch function for fab
                this.$vuetify.goTo(document.getElementById(data), this.options);
            });
        },
    }
</script>

<style scoped>
.relative{
    position: relative;
}
.mock-href{
    background-color: white;
    padding-left: 5px;
    padding-right: 5px;
    color: #0000ff;
    border-radius: 5px;
    text-decoration: underline;
    font-size: 8pt;
    cursor: pointer;
}
.new-accos{
    position:fixed
}
.bg2 {
    width: 100%;
    height: 100%;
    position: fixed; /* absolute */
    top: 0;
    left: 0;
    background: url('./assets/winter2.svg') no-repeat right bottom;
    background-size: cover;
    background-color: white;
    transform: scale(1.1);
}

.bg3 {
    width: 220px;
    height: 100%;
    position: fixed; /* absolute */
    bottom: 0;
    left: 0;
    background: url('./assets/bg-small.png') no-repeat left bottom;
    background-color: white;
}
</style>
